<script setup lang="ts">
import type { ToastTitleProps } from 'reka-ui'
import type { HTMLAttributes } from 'vue'
import { ToastTitle } from 'reka-ui'

const props = defineProps<ToastTitleProps & { class?: HTMLAttributes['class'] }>()
const appConfig = useAppConfig()
const delegatedProps = computed(() => {
  const { class: _, ...delegated } = props
  return delegated
})
</script>

<template>
  <ToastTitle v-bind="delegatedProps" :class="cn(appConfig.ui.toast.slots.title, props.class)">
    <slot />
  </ToastTitle>
</template>
